import Vue from "vue"
import Router from "vue-router"
import elderManage from "./utils/elderManage" //适老化路由
import oldReplacement from "./utils/oldReplacement" //以旧换新路由
import timeBack from "./utils/timeBack" //时间储蓄路由
import bedPage from "./utils/bedRouter" //床位管理
import fiveLinkage from "./utils/fiveLinkage" //五社联动
import elderlyService from "./utils/elderlyService" //养老服务
import stationService from "./utils/stationService" //站点服务
import trainSystem from "./utils/trainSystem" //人才培训系统
import callCenter from "./utils/callCenter" //呼叫中心
import olderInstitution from "./utils/olderInstitution" // 养老机构
import civilAdministrationSupervision from "./utils/civilAdministrationSupervision" // 养老机构
import regulatoryPlatform from "./utils/regulatoryPlatform" // 监管平台
import store from "./store"
import partybuildSystem from "./utils/partybuildSystem"
// 解决vue路由导航报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: "/oldManStatistics",
      name: "oldManStatistics",
      component: () =>
        import(// 以前对应的组件
        // import ('./views/platform/provideManage/oldManStatistics.vue')

        // 机构养老一张图对应组件
        "./views/platform/InstitutionalOldmanImg/index.vue")
    },
    {
      path: "/dataCenterindex",
      name: "dataCenterindex",
      component: () =>
        import(// 党建可视化
        "./views/platform/partyBuilding/PartyBuildingVisualization.vue")
    },
    elderManage,
    oldReplacement,
    timeBack,
    bedPage,
    fiveLinkage,
    elderlyService,
    stationService,
    trainSystem,
    callCenter,
    olderInstitution,
    civilAdministrationSupervision,
    regulatoryPlatform,
    partybuildSystem,
    // 呼叫中心可视化
    {
      path: "/oldBigData",
      name: "oldBigData",
      component: () => import("./views/callCenter/bigdatas/bigdata")
    },
    //社区助餐系统
    {
      path: "/orderFood",
      name: "orderFood",
      component: () => import("./components/orderFood/container.vue"),
      children: [
        // 首页
        {
          path: "/orderFoodIndex",
          name: "orderFoodIndex",
          component: () => import("./components/orderFood/index.vue")
        },
        // 助餐站点
        {
          path: "/mealStation",
          name: "mealStation",
          component: () => import("./components/orderFood/mealStation.vue")
        },
        // 养老助餐点
        {
          path: "/oldPoint",
          name: "oldPoint",
          component: () => import("./components/orderFood/oldPoint.vue")
        },

        // 用户管理
        {
          path: "/userManage",
          name: "userManage",
          component: () => import("./components/orderFood/userManage/index.vue")
        },
        // 水心亭
        {
          path: "/shuiManage",
          name: "shuiManage",
          component: () => import("./components/orderFood/shuiManage/index.vue")
        },
        // 水心亭用户调查
        {
          path: "/shuiInvestigate",
          name: "shuiInvestigate",
          component: () =>
            import("./components/orderFood/shuiInvestigate/index.vue")
        },
        // 消费记录
        {
          path: "/consumption",
          name: "consumption",
          component: () =>
            import("./components/orderFood/consumption/index.vue")
        },
        // 订餐管理
        {
          path: "/foodManage",
          name: "foodManage",
          component: () =>
            import("./components/orderFood/orderManage/foodManage.vue")
        },
        //用餐调查
        {
          path: "/diningSurvey",
          name: "diningSurvey",
          component: () =>
            import("./components/orderFood/diningSurvey/index.vue")
        },
        // 支付管理首页
        {
          path: "/paymentIndex",
          name: "paymentIndex",
          component: () => import("./components/orderFood/payment/index.vue")
        },
        // 支付信息
        {
          path: "/paymentInfo",
          name: "paymentInfo",
          component: () =>
            import("./components/orderFood/payment/paymentInformation.vue")
        },
        // 人员管理
        {
          path: "/peopleManage",
          name: "peopleManage",
          component: () => import("./components/orderFood/peopleManage.vue")
        },
        // 菜品信息
        {
          path: "/information",
          name: "varietydishesinformation",
          component: () =>
            import("./components/orderFood/varietydishes/information.vue")
        },
        // 每周菜单
        {
          path: "/menuWeekly",
          name: "varietydishesmenu",
          component: () =>
            import("./components/orderFood/varietydishes/menuWeekly.vue")
        },
        // 原料维护
        {
          path: "/material",
          name: "orderFoodmaterial",
          component: () =>
            import("./components/orderFood/basicData/material.vue")
        },
        // 固定资产
        {
          path: "/equipment",
          name: "orderFoodequipment",
          component: () =>
            import("./components/orderFood/basicData/equipment.vue")
        },
        // 餐补等级
        {
          path: "/foodSupplement",
          name: "orderFoodfood",
          component: () =>
            import("./components/orderFood/basicData/foodSupplement.vue")
        },
        {
          path: "/foodPolicy",
          name: "foodPolicy",
          mate: {
            title: "助餐政策"
          },
          component: () =>
            import("./components/orderFood/basicData/foodPolicy.vue")
        },
        {
          path: "/foodPrice",
          name: "foodPrice",
          mate: {
            title: "菜单价格"
          },
          component: () =>
            import("./components/orderFood/basicData/foodPrice.vue")
        },
        {
          path: "/serviceStyle",
          name: "serviceStyle",
          mate: {
            title: "服务风采"
          },
          component: () =>
            import("./components/orderFood/basicData/serviceStyle.vue")
        }
      ]
    },

    //走访探视
    {
      path: "/visitContainer",
      name: "visitContainer",
      component: () => import("./components/visit/container.vue"),
      children: [
        // 首页
        {
          path: "/visitIndex",
          name: "visitIndex",
          component: () => import("./components/visit/index.vue")
        },
        // 老人管理
        {
          path: "/oldAdministration",
          name: "oldAdministration",
          component: () =>
            import("./components/visit/oldAdministration/oldIndex.vue")
        },
        // 走访清单
        {
          path: "/visitList",
          name: "visitList",
          component: () => import("./components/visit/visitList/listIndex.vue")
        },
        // 走访类型设置
        {
          path: "/visitType",
          name: "visitType",
          component: () => import("./components/visit/visitType/typeIndex.vue")
        },
        // 服务人员管理
        {
          path: "/servicePeople",
          name: "servicePeople",
          component: () => import("./components/visit/peopleManage.vue"),
          mate: {
            title: "服务人员管理"
          }
        },
        // 信息服务工单
        {
          path: "/infoserviceWorder",
          name: "infoserviceWorder",
          component: () =>
            import("./components/visit/infoserviceWorder/infoIndex.vue"),
          mate: {
            title: "信息服务工单"
          }
        }
      ]
    },
    // 监管可视化平台可视化
    {
      path: "/Supervisoryvisualization",
      name: "Supervisoryvisualization",
      component: () => import("./views/Supervisoryvisualization/main.vue"),
      children: [
        // 监管可视化
        {
          path: "/supVisit",
          name: "supVisit",
          component: () =>
            import("./views/Supervisoryvisualization/supVisit/index.vue")
        }
      ]
    },
    //养老一张图
    {
      path: "/bigDataPlatform",
      name: "bigDataPlatform",
      mate: {
        title: "养老一张图"
      },
      component: () => import("./views/bigDataPlatform/index.vue")
    },
    // 老养老一张图居家养老
    {
      path: "/homeOldage",
      name: "homeOldage",
      component: () => import("./views/bigDataPlatform/homeOldage.vue")
    },
    // 老养老一张图适老化
    {
      path: "/suitableAging",
      name: "suitableAging",
      component: () => import("./views/bigDataPlatform/suitableAging.vue")
    },
    // 老养老一张图社区养老
    {
      path: "/homeComage",
      name: "homeComage",
      component: () => import("./views/bigDataPlatform/homeComage.vue")
    },
    // 老养老一张图床位管理
    {
      path: "/homeBedage",
      name: "homeBedage",
      component: () => import("./views/bigDataPlatform/homeBedage.vue")
    },
    // 养老一张图社区养老机构养老
    {
      path: "/oldhomeOrgage",
      name: "oldhomeOrgage",
      component: () => import("./views/bigDataPlatform/oldhomeOrgage.vue")
    },
    // 养老一张图助餐
    {
      path: "/meal",
      name: "meal",
      component: () => import("./views/bigDataPlatform/mealOld.vue")
    },
    // 时间储蓄
    {
      path: "/time",
      name: "time",
      component: () => import("./views/bigDataPlatform/timeBank.vue")
    },
    // 养老一张图智能化
    // {
    //   path: "/facility",
    //   name: "facility",
    //   component: () => import("./views/bigDataPlatform/facility.vue")
    // },
    {
      path: "/facility",
      name: "facility",
      component: () => import("./views/bigDataPlatform/facility.vue")
    },

    //----------------------------------分割线----------------------------------------
    //  新地址带new做路由，老地址还需要
    // 新养老一张图居家养老
    {
      path: "/newHomeOldage",
      name: "newHomeOldage",
      component: () => import("./views/bigDataPlatform/newHomeOldage.vue")
    },
    // //新养老一张图适老化
    {
      path: "/newSuitableAging",
      name: "newSuitableAging",
      component: () => import("./views/bigDataPlatform/suitableAging/index.vue")
    },

    {
      path: "/newhomeBedage",
      name: "newhomeBedage",
      component: () => import("./views/bigDataPlatform/newhomeBedage.vue")
    },
      //社区养老
    {
      path: "/newHomeComage",
      name: "newHomeComage",
      component: () => import("./views/bigDataPlatform/newHomeComage.vue")
    },
    //社区养老
    {
      path: "/homeOrgage",
      name: "homeOrgage",
      component: () => import("./views/bigDataPlatform/homeOrgage.vue")
    },
    // 养老一张图设备
    {
      path: "/newfacility",
      name: "newfacility",
      component: () => import("./views/bigDataPlatform/newfacility.vue")
    },

    // 养老一张图设备
    {
      path: "/retirementBigData",
      name: "retirementBigData",
      component: () => import("./views/bigDataPlatform/retirementBigData/index.vue")
    },

    // 时间储蓄
    {
      path: "/newTime",
      name: "newTime",
      component: () => import("./views/bigDataPlatform/newTimeBank.vue")
    },
    // 养老一张图助餐
    {
      path: "/newMeal",
      name: "newMeal",
      component: () => import("./views/bigDataPlatform/meal.vue")
    },
    // 养老可视化
    {
      path: "/visualization",
      name: "visualization",
      component: () => import("./views/visualization/main.vue"),
      children: [
        // 适老化
        {
          path: "/olderman",
          name: "olderman",
          component: () => import("./views/visualization/olderman/index.vue")
        },
        // 走访探视
        {
          path: "/visit",
          name: "visit",
          component: () => import("./views/visualization/visit/index.vue")
        },
        // 时间储蓄
        {
          path: "/date",
          name: "date",
          component: () => import("./views/visualization/date/index.vue")
        },
        // 床位管理
        {
          path: "/bedManage",
          name: "bedManage",
          component: () => import("./views/visualization/bedManage/index.vue")
        },
        {
          path: "/mealAid",
          name: "mealAid",
          component: () => import("./views/visualization/mealAid/index.vue")
        },
      //    分割线  第三次大屏
        // 养老一张图设备
        {
          path: "/retirementBigData_a",
          name: "retirementBigData_a",
          component: () => import("./views/bigDataPlatform/retirementBigData/retirementBigData_a.vue")
        },
      ]
    },

    // 黄冈
    {
      path: "/home",
      name: "home",
      meta: {
        index: 1
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/hgVisit/home.vue"),
      redirect: "/hgVisit",
      children: [
        {
          path: "/hgVisit",
          name: "hgVisit",
          meta: {
            index: 1
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/hgVisit/index.vue")
        },
        {
          path: "/hgVisit1",
          name: "hgVisit1",
          meta: {
            index: 2
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/hgVisit/hgVisits.vue")
        },
        {
          path: "/hgVisit2",
          name: "hgVisit2",
          meta: {
            index: 3
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/hgVisit/three.vue")
        }
      ]
    },
    //来安
    {
      path: "/home",
      name: "home",
      meta: {
        index: 1
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/laVisit/home.vue"),
      redirect: "/laVisit",
      children: [
        {
          path: "/laVisit",
          name: "laVisit",
          meta: {
            index: 1
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/laVisit/index.vue")
        },
        {
          path: "/laVisit1",
          name: "laVisit1",
          meta: {
            index: 2
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/laVisit/hgVisits.vue")
        },
        {
          path: "/laVisit2",
          name: "laVisit2",
          meta: {
            index: 3
          },
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/laVisit/three.vue")
        }
      ]
    },
    //智能监控
    {
      path: "/znjk",
      name: "znjk",
      meta: {
        index: 1
      },
      component: () => import("./views/znjk/znjk.vue"),
      redirect: "/znjk"
      // children: [
      //     {
      //         path: '/znjk',
      //         name: 'znjk',
      //         meta: {
      //             index: 1
      //         },
      //         component: () => import ('./views/znjk/znjk.vue'),

      //     }
      // ]
    },
    //街道一张图
    {
      path: "/streetMap",
      name: "streetMap",
      meta: {
        index: 1
      },
      component: () => import("./views/streetMap/streetMap.vue")
    },

    // 系统设置
    {
      path: "/system",
      name: "system",
      meta: {
        index: 5
      },
      component: () => import("./views/system.vue"),
      redirect: "/organization",
      children: [
        // 组织机构管理
        {
          path: "/organization",
          name: "organization",
          meta: {
            index: 51
          },
          component: () => import("./views/system/organization.vue"),
          redirect: "/organizationIndex",
          children: [
            {
              path: "/organizationIndex",
              name: "organizationIndex",
              meta: {
                index: 511
              },
              component: () =>
                import("./views/system/organization/organizationIndex.vue")
            },
            // 按组织授权
            {
              path: "/assignOrganization",
              name: "assignOrganization",
              meta: {
                index: 512
              },
              component: () =>
                import("./views/system/assign/assignOrganization.vue")
            },
            {
              path: "/assignRole",
              name: "assignRole",
              meta: {
                index: 512
              },
              component: () => import("./views/system/assign/assignRole.vue")
            },
            //菜单管理
            {
              path: "/rightIndex",
              name: "rightIndex",
              meta: {
                index: 531
              },
              component: () => import("./views/system/right/rightIndex.vue")
            },
            {
              path: "/roleIndex",
              name: "roleIndex",
              meta: {
                index: 521
              },
              component: () => import("./views/system/role/roleIndex.vue")
            },
            //职位管理
            {
              path: "/positionManagement",
              name: "positionManagement",
              meta: {
                index: 531
              },
              component: () => import("./views/system/positionManagement.vue")
            },
            // 按角色授权
            // {
            //     path: '/roleRight',
            //     name: 'roleRight',
            //     meta: {
            //         index: 522
            //     },
            //     component: () =>
            //         import ('./views/system/role/roleRight.vue'),
            // },
            {
              path: "/onlineIndex",
              name: "onlineIndex",
              meta: {
                index: 541
              },
              component: () => import("./views/system/online/onlineIndex.vue")
            },

            // {
            //     path: '/onlineMsg',
            //     name: 'onlineMsg',
            //     meta: {
            //         index: 543
            //     },
            //     component: () =>
            //         import ('./views/system/online/onlineMsg.vue'),
            // },
            {
              path: "/userIndex",
              name: "userIndex",
              meta: {
                index: 551
              },
              component: () => import("./views/system/user/userIndex.vue")
            },
            {
              path: "/userLog",
              name: "userLog",
              meta: {
                index: 552
              },
              component: () => import("./views/system/user/userLog.vue")
            },
            {
              path: "/AddressManagement",
              name: "AddressManagement",
              meta: {
                index: 553
              },
              component: () => import("./views/system/AddressManagement.vue")
            },
            // {
            //     path: "/productManage", //产品管理
            //     name: "productManage",
            //     component: () =>
            //         import ("./views/system/productManage.vue"),
            //     mate: {
            //         title: '产品管理'
            //     }
            // },
            {
              path: "/dictionaries", //数字字典
              name: "dictionaries",
              component: () => import("./views/system/dictionaries"),
              mate: {
                title: "字典"
              }
            },

            {
              path: "/addressLibrary", //标准地址库
              name: "addressLibrary",
              component: () => import("./views/system/addressLibrary"),
              mate: {
                title: "标准地址库"
              }
            },
            {
              path: "/streetManage", //jiedao管理
              name: "streetManage",
              component: () => import("./views/system/streetManage"),
              mate: {
                title: "街道管理"
              }
            },
            // {
            //   path: '/userLogin',
            //   name: 'userLogin',
            //   meta: {
            //     index: 553
            //   },
            //   component: () => import('./views/system/user/userLogin.vue'),
            // },
            //  字典管理
            {
              path: "/dicIndex",
              name: "dicIndex",
              meta: {
                index: 561
              },
              component: () => import("./views/system/dic/dicIndex.vue")
            },
            //  字典数据 /:dictId(\\d+)
            {
              path: "/dicData/:dictId",
              name: "dicData",
              meta: {
                index: 561
              },
              component: () => import("./views/system/dic/data.vue")
            }
            // 部门管理
            // {
            //     path: '/departmentIndex',
            //     name: 'departmentIndex',
            //     meta: {
            //         index: 561
            //     },
            //     component: () =>
            //         import ('./views/system/department/departmentIndex.vue'),
            // },
            // {
            //     path: '/onlineSms',
            //     name: 'onlineSms',
            //     meta: {
            //         index: 542
            //     },
            //     component: () =>
            //         import ('./views/system/online/onlineSms.vue'),
            // },
            // //  短信发送
            // {
            //     path: '/onlineSmsSend',
            //     name: 'onlineSmsSend',
            //     meta: {
            //         index: 542
            //     },
            //     component: () =>
            //         import ('./views/system/online/onlineSmsSend.vue'),
            // },
            //  短信模板
            // {
            //     path: '/smsTemplate',
            //     name: 'smsTemplate',
            //     meta: {
            //         index: 542
            //     },
            //     component: () =>
            //         import ('./views/system/online/smsTemplate.vue'),
            // },
            // //  业委会管理
            // {
            //     path: '/sPropertyServices',
            //     name: 'sPropertyServices',
            //     meta: {
            //         index: 561
            //     },
            //     component: () =>
            //         import ('./views/system/ywh/sPropertyServices.vue'),
            // },
          ]
        }
      ]
    },

    // 登录页
    {
      path: "/login",
      name: "login",
      meta: {
        index: 0
      },
      component: () =>
        import("./views/login.vue") /* webpackChunkName: "about" */
    },
    // 新登录页
    {
      path: "/login1",
      name: "login1",
      meta: {
        index: 0
      },
      component: () =>
        import("./views/login1.vue") /* webpackChunkName: "about" */
    },
    {
      path: "/homeindex",
      name: "homeindex",
      meta: {
        index: 1
      },
      component: () =>
        import("./views/homeindex.vue") /* webpackChunkName: "about" */
    },

    {
      path: "/",
      redirect: "/login"
    },

    //
    // 社区治理old
    {
      path: "/governmentAffairs",
      name: "governmentAffairs",
      meta: {
        index: 21
      },
      component: () =>
        import("./views/governmentAffairs.vue") /* webpackChunkName: "about" */
    },

    // 社区治理-网格管理
    {
      path: "/Gridding",
      name: "Gridding",
      redirect: "",
      meta: {
        index: 211
      },
      component: () => import("./views/governmentAffairschildren/Gridding.vue"),
      /* webpackChunkName: "about" */
      children: [
        //社区治理人员管理系统
        {
          path: "/personnelManagementSystem",
          name: "personnelManagementSystem",
          meta: {
            index: 2113
          },
          component: () =>
            import("./views/governmentAffairschildren/gridding/personnelManagementSystem.vue") /* webpackChunkName: "about" */
        },
        {
          path: "/griddingList",
          name: "griddingList",
          meta: {
            index: 211
          },
          redirect: "/videoMonitor",
          component: () =>
            import("./views/governmentAffairschildren/griddingList.vue"),
          /* webpackChunkName: "about" */
          children: [
            // 社区环保
            {
              path: "/videoMonitor",
              name: "videoMonitor",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/videoMonitor.vue") /* webpackChunkName: "about" */
            }
          ]
        }
      ]
    },

    // {
    //   path: '/dataCentreindex2',
    //   name: 'dataCentreindex2',
    //   meta: { index: 542 },
    //   component: () => import('./views/governmentAffairschildren/dataCentre/dataCentreindextest.vue'),
    // },

    // 总头

    {
      path: "/commonHeader",
      name: "commonHeader",
      meta: {
        index: 211
      },
      component: () =>
        import("./views/governmentAffairschildren/commonHeader.vue"),
      /* webpackChunkName: "about" */
      children: [
        //新首页
        {
          path: "/newIndex",
          name: "newIndex",
          meta: {
            index: 4
          },
          component: () => import("./views/platform/newIndex.vue"),
          redirect: "/newIindex",
          children: [
            //便民服务首页
            {
              path: "/newIindex",
              name: "newIindex",
              meta: {
                index: 331
              },
              component: () => import("./views/platform/newIndex/newIindex.vue")
            }
          ]
        },

        //智慧政务
        {
          path: "/zhengwu",
          name: "zhengwu",
          meta: {
            index: 21
          },
          component: () =>
            import("./views/governmentAffairschildren/zhengwu.vue"),
          redirect: "/zhzw",
          children: [
            {
              path: "/zhzw",
              name: "zhzw",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/zhzw/zhzw.vue")
            },
            {
              path: "/oneStopProcessingTemplate",
              name: "oneStopProcessingTemplate",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/zhzw/oneStopProcessingTemplate.vue")
            },
            {
              path: "/oneStopProcessing",
              name: "oneStopProcessing",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/zhzw/oneStopProcessing.vue")
            },
            {
              path: "/oneStopProcessingConsult",
              name: "oneStopProcessingConsult",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/zhzw/oneStopProcessingConsult.vue")
            },
            {
              path: "/oneStopProcessingProve",
              name: "oneStopProcessingProve",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/zhzw/oneStopProcessingProve.vue")
            },
            {
              path: "/mzjz",
              name: "mzjz",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/mzjz.vue")
            },
            {
              path: "/tyjrsw",
              name: "tyjrsw",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/tyjrsw.vue")
            },
            {
              path: "/rsbz",
              name: "rsbz",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/rsbz.vue")
            },
            {
              path: "/cjrbz",
              name: "cjrbz",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/cjrbz.vue")
            },
            {
              path: "/wsjk",
              name: "wsjk",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/wsjk.vue")
            },
            {
              path: "/gzfsq",
              name: "gzfsq",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/gzfsq.vue")
            },
            {
              path: "/sqjs",
              name: "sqjs",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/policyInfo/sqjs.vue")
            }
            // {
            //   path: '/onlineSms',
            //   name: 'onlineSms',
            //   meta: {
            //     index: 542
            //   },
            //   component: () => import('./views/system/online/onlineSms.vue'),
            // },
            //   //  短信发送
            //   {
            //     path: '/onlineSmsSend',
            //     name: 'onlineSmsSend',
            //     meta: {
            //       index: 542
            //     },
            //     component: () => import('./views/system/online/onlineSmsSend.vue'),
            //   },
            //   //  短信模板
            //   {
            //     path: '/smsTemplate',
            //     name: 'smsTemplate',
            //     meta: {
            //       index: 542
            //     },
            //     component: () => import('./views/system/online/smsTemplate.vue'),
            //   },
          ]
        },
        // z智慧养老一张图
        {
          path: "/provideImage",
          name: "provideImage",
          component: () =>
            import("./views/platform/provideManage/provideImage.vue")
        },
        // 智慧养老
        {
          path: "/provideManage",
          name: "provideManage",
          meta: {
            index: 33
          },
          component: () => import("./views/platform/provideManage.vue"),
          redirect: "/oldManFile",
          children: [
            {
              path: "/oldManFile",
              name: "oldManFile",
              component: () =>
                import("./views/platform/provideManage/oldManFile.vue")
            },

            {
              path: "/addOldManFile",
              name: "addOldManFile",
              component: () =>
                import("./views/platform/provideManage/addOldManFile.vue")
            },
            {
              path: "/serveProject",
              name: "serveProject",
              component: () =>
                import("./views/platform/provideManage/serveProject.vue")
            },
            {
              path: "/serveCompany",
              name: "serveCompany",
              component: () =>
                import("./views/platform/provideManage/serveCompany.vue")
            },
            {
              path: "/serveCompanyDetail",
              name: "serveCompanyDetail",
              component: () =>
                import("./views/platform/provideManage/serveCompanyDetail.vue")
            },
            {
              path: "/serveWorkOrder",
              name: "serveWorkOrder",
              component: () =>
                import("./views/platform/provideManage/serveWorkOrder.vue")
            },

            {
              path: "/provideOrganization",
              name: "provideOrganization",
              component: () =>
                import("./views/platform/provideManage/provideOrganization.vue")
            },
            {
              path: "/provideOrganizationInfo",
              name: "provideOrganizationInfo",
              component: () =>
                import("./views/platform/provideManage/provideOrganizationInfo.vue")
            },
            {
              path: "/provideMap",
              name: "provideMap",
              component: () =>
                import("./views/platform/provideManage/provideMap.vue")
            },

            {
              path: "/provideHeKangServeObject",
              name: "provideHeKangServeObject",
              component: () =>
                import("./views/platform/provideManage/provideHeKangServeObject.vue")
            },
            {
              path: "/provideHeKangWorkOrder",
              name: "provideHeKangWorkOrder",
              component: () =>
                import("./views/platform/provideManage/provideHeKangWorkOrder.vue")
            },
            {
              path: "/provideHeKangServePeople",
              name: "provideHeKangServePeople",
              component: () =>
                import("./views/platform/provideManage/provideHeKangServePeople.vue")
            },

            {
              path: "/provideCommunity",
              name: "provideCommunity",
              component: () =>
                import("./views/platform/provideManage/provideCommunity.vue")
            },
            {
              path: "/provideCommunityInfo",
              name: "provideCommunityInfo",
              component: () =>
                import("./views/platform/provideManage/provideCommunityInfo.vue")
            },
            {
              path: "/communityMap",
              name: "communityMap",
              component: () =>
                import("./views/platform/provideManage/communityMap.vue")
            },
            {
              path: "/serveReturn",
              name: "serveReturn",
              component: () =>
                import("./views/platform/provideManage/serveReturn.vue")
            },
            // {
            //     path: '/oldManStatistics',
            //     name: 'oldManStatistics',
            //     component: () =>
            //         import ('./views/platform/provideManage/oldManStatistics.vue')
            // },
            {
              path: "/workOrderStatistics",
              name: "workOrderStatistics",
              component: () =>
                import("./views/platform/provideManage/workOrderStatistics.vue")
            },
            {
              path: "/organizationStatistics",
              name: "organizationStatistics",
              component: () =>
                import("./views/platform/provideManage/organizationStatistics.vue")
            },
            {
              path: "/consultManage",
              name: "consultManage",
              component: () =>
                import("./views/platform/provideManage/consultManage.vue")
            },

            // {
            //     path: '/provideImage',
            //     name: 'provideImage',
            //     component: () => import('./views/platform/provideManage/provideImage.vue')
            // },
            {
              path: "/assistHelpRecord",
              name: "assistHelpRecord",
              component: () =>
                import("./views/platform/provideManage/assistHelpRecord.vue")
            },
            {
              path: "/servePeople",
              name: "servePeople",
              component: () =>
                import("./views/platform/provideManage/servePeople.vue")
            },
            {
              path: "/serveBack",
              name: "serveBack",
              component: () =>
                import("./views/platform/provideManage/serveBack.vue")
            }
          ]
        },
        // 智慧协商
        {
          path: "/communityConsultation",
          name: "communityConsultation",
          meta: {
            index: 33
          },
          component: () => import("./views/platform/communityConsultation.vue"),
          redirect: "/communityConsultation",
          children: [
            {
              path: "/communityConsultation",
              name: "communityConsultation",
              component: () =>
                import("./views/platform/gridding/communityConsultation.vue")
            },
            {
              path: "/communityIssueTitle",
              name: "communityIssueTitle",
              component: () =>
                import("./views/platform/gridding/communityIssueTitle.vue")
            },
            {
              path: "/communitylssueUp",
              name: "communitylssueUp",
              component: () =>
                import("./views/platform/gridding/communitylssueUp.vue")
            },
            {
              path: "/communitySqOrganization",
              name: "communitySqOrganization",
              component: () =>
                import("./views/platform/gridding/communitySqOrganization.vue")
            },
            {
              path: "/PartyOrganizationManagement",
              name: "PartyOrganizationManagement",
              component: () =>
                import("./views/platform/gridding/PartyOrganizationManagement.vue")
            },
            {
              path: "/regularWork",
              name: "regularWork",
              component: () =>
                import("./views/platform/gridding/regularWork.vue")
            },
            {
              path: "/communityWgOrganization",
              name: "communityWgOrganization",
              component: () =>
                import("./views/platform/gridding/communityWgOrganization.vue")
            },
            {
              path: "/communityIssuePerson",
              name: "communityIssuePerson",
              component: () =>
                import("./views/platform/gridding/communityIssuePerson.vue")
            },
            // {
            //   path: "/communityIssueArea",
            //   name: "communityIssueArea",
            //   component: () =>
            //     import("./views/platform/gridding/communityIssueArea.vue")
            // },
            {
              path: "/communityIssueFg",
              name: "communityIssueFg",
              component: () =>
                import("./views/platform/gridding/communityIssueFg.vue")
            },
            {
              path: "/communityIssueCPerson",
              name: "communityIssueCPerson",
              component: () =>
                import("./views/platform/gridding/communityIssueCPerson.vue")
            },
            {
              path: "/communityIssueType",
              name: "communityIssueType",
              component: () =>
                import("./views/platform/gridding/communityIssueType.vue")
            },
            {
              path: "/communityWgPerson",
              name: "communityWgPerson",
              component: () =>
                import("./views/platform/gridding/communityWgPerson.vue")
            },
            {
              path: "/communitySqPerson",
              name: "communitySqPerson",
              component: () =>
                import("./views/platform/gridding/communitySqPerson.vue")
            }
          ]
        },
        //智慧治理
        {
          path: "/community",
          name: "community",
          meta: {
            index: 542
          },
          component: () =>
            import("./views/governmentAffairschildren/community.vue"),
          children: [
            {
              path: "/griddingindex",
              name: "griddingindex",
              meta: {
                index: 542
              },
              //component: () => import('./views/governmentAffairschildren/gridding/griddingindex.vue'),
              component: () =>
                import("./views/governmentAffairschildren/gridding/gridsidebar.vue")
            },
            {
              path: "/danganguanli",
              name: "danganguanli",
              meta: {
                index: 542
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/danganguanli")
            },
            {
              path: "/regularWork",
              name: "regularWork",
              component: () =>
                import("./views/governmentAffairschildren/gridding/regularWork")
            },
            {
              path: "/shehuizuzhi",
              name: "shehuizuzhi",
              component: () =>
                import("./views/governmentAffairschildren/gridding/shehuizuzhi")
            },
            {
              path: "/shehuigongzuozhe",
              name: "shehuigongzuozhe",
              meta: {
                index: 542
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/shehuigongzuozhe")
            },
            {
              path: "/zhengcexinxi",
              name: "zhengcexinxi",
              meta: {
                index: 542
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/zhengcexinxi")
            },
            {
              path: "/banli",
              name: "banli",
              meta: {
                index: 542
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/banli")
            },
            {
              path: "/manageType",
              name: "manageType",
              meta: {
                index: 542
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/manageType")
            },
            {
              path: "/smartInform",
              name: "smartInform",
              component: () =>
                import("./views/governmentAffairschildren/smart/smartInform.vue")
            },
            {
              path: "/smartsl",
              name: "smartsl",
              component: () =>
                import("./views/governmentAffairschildren/smart/smartsl.vue")
            },
            // 活动列表
            {
              path: "/twoNetworkConvergenceActivity",
              name: "twoNetworkConvergenceActivity",
              meta: {
                index: 337
              },
              component: () =>
                import("./views/governmentAffairschildren/smart/twoNetworkConvergenceActivity.vue")
            },
            //考勤管理 考勤地图
            {
              path: "/attendanceMap",
              name: "attendanceMap",
              component: () =>
                import("./views/platform/gridding/attendanceMap.vue")
            },
            //考勤管理 考勤列表
            {
              path: "/attendanceList",
              name: "attendanceList",
              component: () =>
                import("./views/platform/gridding/attendanceList.vue")
            },
            //考勤管理 考勤时间设置
            {
              path: "/attendanceTime",
              name: "attendanceTime",
              component: () =>
                import("./views/platform/gridding/attendanceTime.vue")
            },
            // 考勤管理
            //考勤管理 申请管理 请假管理
            {
              path: "/leaveManagement",
              name: "leaveManagement",
              component: () =>
                import("./views/platform/gridding/leaveManagement.vue")
            },
            //考勤管理 申请管理 加班管理
            {
              path: "/overtimeManagement",
              name: "overtimeManagement",
              component: () =>
                import("./views/platform/gridding/overtimeManagement.vue")
            },
            //考勤管理 申请管理 补卡申请
            {
              path: "/cardReplacementApplication",
              name: "cardReplacementApplication",
              component: () =>
                import("./views/platform/gridding/cardReplacementApplication.vue")
            },
            //考勤管理 申请管理 换班
            {
              path: "/shiftChange",
              name: "shiftChange",
              component: () =>
                import("./views/platform/gridding/shiftChange.vue")
            },
            //考勤管理 申请管理 外出
            {
              path: "/goOut",
              name: "goOut",
              component: () => import("./views/platform/gridding/goOut.vue")
            },
            // 网格任务
            {
              path: "/gridTask",
              name: "gridTask",
              component: () => import("./views/platform/gridding/gridTask.vue")
            },
            // 网格日志
            {
              path: "/graddingLog",
              name: "graddingLog",
              component: () =>
                import("./views/governmentAffairschildren/smart/graddingLog.vue")
            },
            //投诉与建议
            {
              path: "/communityComplaintAdvice",
              name: "communityComplaintAdvice",
              meta: {
                index: 331
              },
              component: () =>
                import("./views/governmentAffairschildren/communityComplaintAdvice.vue")
            },
            // 基础信息库 特殊人群 学龄人群
            {
              path: "/gridsidebar1",
              name: "gridsidebar1",
              meta: {
                index: 2112
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/gridsidebar.vue") /* webpackChunkName: "about" */
            },
            {
              path: "/gridsidebar2",
              name: "gridsidebar2",
              meta: {
                index: 2112
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/gridsidebar.vue") /* webpackChunkName: "about" */
            },
            {
              path: "/gridsidebar3",
              name: "gridsidebar3",
              meta: {
                index: 2112
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/gridsidebar.vue") /* webpackChunkName: "about" */
            },
            {
              path: "/gridsidebar4",
              name: "gridsidebar4",
              meta: {
                index: 2112
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/gridsidebar.vue") /* webpackChunkName: "about" */
            },
            // 网格工作 网格巡查
            {
              path: "/networkPatrolRw",
              name: "networkPatrolRw",
              component: () =>
                import("./views/governmentAffairschildren/gridding/networkPatrolRw.vue")
            },
            {
              path: "/networkPatrolLx",
              name: "networkPatrolLx",
              component: () =>
                import("./views/governmentAffairschildren/gridding/networkPatrolLx.vue")
            },
            {
              path: "/networkPatrolFp",
              name: "networkPatrolFp",
              component: () =>
                import("./views/governmentAffairschildren/gridding/networkPatrolFp.vue")
            },
            {
              path: "/networkPatrolJd",
              name: "networkPatrolJd",
              component: () =>
                import("./views/governmentAffairschildren/gridding/networkPatrolJd.vue")
            },
            {
              path: "/networkPatrolJl",
              name: "networkPatrolJl",
              component: () =>
                import("./views/governmentAffairschildren/gridding/networkPatrolJl.vue")
            },
            {
              path: "/networkPatrolJdPerson",
              name: "networkPatrolJdPerson",
              meta: {
                index: 4,
                title: "person"
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/networkPatrolJdPerson.vue")
            },
            {
              path: "/networkPatrolJlPerson",
              name: "networkPatrolJlPerson",
              meta: {
                index: 4,
                title: "person"
              },
              component: () =>
                import("./views/governmentAffairschildren/gridding/networkPatrolJlPerson.vue")
            }
          ]
        },
        //文明创建
        {
          path: "/civilization",
          name: "civilization",
          meta: {
            index: 21
          },
          component: () =>
            import("./views/civilizationCreation/civilization.vue"),
          redirect: "/articleManagement",
          children: [
            {
              path: "/articleManagement",
              name: "articleManagement",
              component: () =>
                import("./views/civilizationCreation/articleManagement.vue")
            },
            {
              path: "/albumManagement",
              name: "albumManagement",
              component: () =>
                import("./views/civilizationCreation/albumManagement.vue")
            },
            {
              path: "/civilizedVolunteers",
              name: "civilizedVolunteers",
              component: () =>
                import("./views/civilizationCreation/civilizedVolunteers.vue")
            },
            {
              path: "/commentManagement",
              name: "commentManagement",
              component: () =>
                import("./views/civilizationCreation/commentManagement.vue")
            },
            {
              path: "/columnManagement",
              name: "columnManagement",
              component: () =>
                import("./views/civilizationCreation/columnManagement.vue")
            },
            {
              path: "/siteManagement",
              name: "siteManagement",
              component: () =>
                import("./views/civilizationCreation/siteManagement.vue")
            },
            {
              path: "/unitInformationMaintenance",
              name: "unitInformationMaintenance",
              component: () =>
                import("./views/civilizationCreation/unitInformationMaintenance.vue")
            },
            {
              path: "/userManagement",
              name: "userManagement",
              component: () =>
                import("./views/civilizationCreation/userManagement.vue")
            },
            {
              path: "/systemNotification",
              name: "systemNotification",
              component: () =>
                import("./views/civilizationCreation/systemNotification.vue")
            }
          ]
        },
        //智慧平安
        {
          path: "/pingan",
          name: "pingan",
          meta: {
            index: 21
          },
          component: () =>
            import("./views/governmentAffairschildren/pingan.vue"),
          redirect: "/theGridManagement",
          children: [
            {
              path: "/theGridManagement",
              name: "theGridManagement",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/theGridManagement/theGridManagement.vue")
            },
            {
              path: "/publicSafety",
              name: "publicSafety",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/theGridManagement/publicSafety.vue")
            },
            {
              path: "/renYuanXinXi",
              name: "renYuanXinXi",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/theGridManagement/renYuanXinXi.vue")
            },
            {
              path: "/faceMonitor",
              name: "faceMonitor",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/theGridManagement/faceMonitor.vue")
            },
            {
              path: "/faceMonitor2",
              name: "faceMonitor2",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/theGridManagement/faceMonitor2.vue")
            },
            {
              path: "/faceMonitor3",
              name: "faceMonitor3",
              meta: {
                index: 2111
              },
              component: () =>
                import("./views/governmentAffairschildren/theGridManagement/faceMonitor3.vue")
            }
          ]
        },
        //大数据平台
        {
          path: "/dataCentreindex",
          name: "dataCentreindex",
          meta: {
            index: 542
          },
          component: () =>
            import("./views/governmentAffairschildren/dataCentre/dataCentreindex.vue")
        },
        {
          path: "/dataCentreindex2",
          name: "dataCentreindex2",
          meta: {
            index: 542
          },
          component: () =>
            import("./views/governmentAffairschildren/dataCentre/dangjian.vue")
        },

        //物业服务
        {
          path: "/wuye",
          name: "wuye",
          meta: {
            index: 2114
          },
          component: () =>
            import("./views/governmentAffairschildren/wuyefuwu.vue"),
          redirect: "/wyDisputeType",
          children: [
            {
              path: "/wyDisputeType",
              name: "wyDisputeType",
              component: () =>
                import("./views/governmentAffairschildren/propertyService/wyDisputeType.vue")
            },
            {
              path: "/wyProblemSell",
              name: "wyProblemSell",
              component: () =>
                import("./views/governmentAffairschildren/propertyService/wyProblemSell.vue")
            },
            {
              path: "/wyPropertys",
              name: "wyPropertys",
              component: () =>
                import("./views/governmentAffairschildren/propertyService/wyPropertys.vue")
            }
          ]
        },
        //投诉与建议
        {
          path: "/communityComplaintAdvice",
          name: "communityComplaintAdvice",
          meta: {
            index: 331
          },
          component: () =>
            import("./views/governmentAffairschildren/communityComplaintAdvice.vue")
        },
        // 党员管理-党员一线报道
        {
          path: "/partyReported",
          name: "partyReported",
          meta: {
            index: 331
          },
          component: () =>
            import("./views/governmentAffairschildren/partyBuilding/partyReported.vue")
        },
        //政策信息
        {
          path: "/policyInfo",
          name: "policyInfo",
          meta: {
            index: 331
          },
          component: () =>
            import("./views/governmentAffairschildren/policyInfo.vue")
        },
        //办事指南
        {
          path: "/businessGuide",
          name: "businessGuide",
          meta: {
            index: 2114
          },
          component: () =>
            import("./views/governmentAffairschildren/businessGuide.vue"),
          redirect: "/businessGuideIndex",
          children: [
            {
              path: "/businessGuideIndex",
              name: "businessGuideIndex",
              component: () =>
                import("./views/governmentAffairschildren/businessGuide/businessGuideIndex.vue")
            },
            {
              path: "/businessGuideList",
              name: "businessGuideList",
              component: () =>
                import("./views/governmentAffairschildren/businessGuide/businessGuideList.vue")
            },
            {
              path: "/businessGuideType",
              name: "businessGuideType",
              component: () =>
                import("./views/governmentAffairschildren/businessGuide/businessGuideType.vue")
            },
            {
              path: "/oneStopProcessing",
              name: "oneStopProcessing",
              component: () =>
                import("./views/governmentAffairschildren/businessGuide/oneStopProcessing.vue")
            },
            {
              path: "/oneStopProcessingTemplate",
              name: "oneStopProcessingTemplate",
              component: () =>
                import("./views/governmentAffairschildren/businessGuide/oneStopProcessingTemplate.vue")
            },
            {
              path: "/oneStopProcessingProve",
              name: "oneStopProcessingProve",
              component: () =>
                import("./views/governmentAffairschildren/businessGuide/oneStopProcessingProve.vue")
            },
            {
              path: "/oneStopProcessingConsult",
              name: "oneStopProcessingConsult",
              component: () =>
                import("./views/governmentAffairschildren/businessGuide/oneStopProcessingConsult.vue")
            }
          ]
        }
      ]
    },
    {
      path: "/hekang",
      name: "hekang",
      meta: {
        index: 1
      },
      component: () =>
        import("./views/hekang.vue") /* webpackChunkName: "about" */
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuth = sessionStorage.getItem("tokens")
    ? sessionStorage.getItem("tokens")
    : ""
  if (
    to.path !== "/login" &&
    to.path !== "/homeBedage" &&
    to.path !== "/login1" &&
    isAuth == ""
  ) {
    next({
      path: "/login"
    })
  } else if (to.path === "/homeBedage" && isAuth == "") {
    next({
      path: "/login1"
    })
  } else {
    next()
  }
})
export default router
